<template>
  <Modal v-if="showModalReservedLockers" @close="$emit('closeAllModal')">
    <div class="reservedLockers">
      <div class="reservedLockers__body">
        <div>
          <p class="text">
            {{ getChoosedLockers(choosedLockers) }}
          </p>
          <p v-if="!isAPIReservations" class="text">
            {{ $t('kolliID') }}: {{ deliveryId }}
          </p>
        </div>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeAllModal')"
        />
      </div>
      <div class="reservedLockers__buttons">
        <Button
          class="reservedLockers__button"
          variant="filled"
          :title="$t('ok')"
          @click="$emit('closeAllModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ReservedLockers',
  props: ['showModalReservedLockers', 'choosedLockers', 'deliveryId'],
  emits: ['closeAllModal'],
  computed: {
    isAPIReservations() {
      return this.$route.name === 'APIReservations';
    }
  },
  methods: {
    getChoosedLockers(choosedLockers: Array<string>) {
      if (choosedLockers.length === 1) {
        const locker = Object.values(choosedLockers).join('');

        return `${this.$t('locker')} ${locker} ${this.$t('reservedText')}`;
      } else if (choosedLockers.length === 2) {
        const firstLocker = choosedLockers[0];
        const secondLcker = choosedLockers[1];

        return `${this.$t('lockers')} ${firstLocker} ${this.$t(
          'and'
        )} ${secondLcker} ${this.$t('reservedText')}`;
      } else if (choosedLockers.length >= 3) {
        const lastLocker = choosedLockers.pop();
        const lockersWithoutLast = choosedLockers.join(', ');

        return `${this.$t('lockers')} ${lockersWithoutLast} ${this.$t(
          'and'
        )} ${lastLocker} ${this.$t('reservedText')}`;
      }
    }
  }
})
export default class ReservedLockers extends Vue {}
</script>

<style lang="scss" scoped>
.reservedLockers {
  width: 390px;
  height: 100%;
  padding: 24px;
  .reservedLockers__body {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
